import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import {
  getFlagApplicableService,
  getFlagSearchList,
} from "../Actions/lookupAPI";
import MinusIcon from "../UIComponents/MinusIcon";
import { RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import AddIcon from "../UIComponents/AddIcon";
import axios from "axios";
import API from "../helpers/api";
import { postFlagAttachment } from "../Actions/CommonAPI";
import { DownloadAttachment } from "../Actions/AttachmentAPI";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Autocomplete from "react-autocomplete";
import {
  getApplicableServiceTypeListWithInterval,
  getEquipmentNameListAndId,
} from "../Actions/helpersAPI";
import { validateFields } from "../Utils/utilities";
import swal from "sweetalert";
import { confirmAlert } from "react-confirm-alert";
import $ from "jquery";
import { t } from "i18next";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

let searchData = {
  PortName: "",
  Country: "",
  PageNumber: 1,
  PageSize: 20,
};
class FlagDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flaginfo: {
        flagId: 0,
        countryname: "",
        attachmentName: "",
        attachmentGuid: "",
        isDeleted: false,
        modifiedBy: currentuser.name,
        equipmentName: "",
        equipmentId: 0,
        capacity: "",
        category: "",
        equipmentType: "",
      },
      file: "",
      fileName: "",
      modalIsOpen: false,
      ApplicableServices: [],
      ApplicableServicesList: [],
      ServiceTypeList: [],
      selectedServiceYears: [],
      isFlagNew: true,

      openEquipment: false,
    };
  }

  async componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(getEquipmentNameListAndId());
    dispatch({ type: "SubBannerTitle", data: "Flag" });

    dispatch(getFlagApplicableService(match.params.id));
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      flagDetail,
      dispatch,
      FlagAttachment,
      GetFlagApplicableService,
      applicableServiceType,
      FlagApplicableServices,
      match,
    } = nextProps;
    if (flagDetail && flagDetail !== "") {
      prevState.flaginfo.flagId = flagDetail.flagId;
      prevState.flaginfo.countryname = flagDetail.countryName;
      prevState.flaginfo.attachmentName = flagDetail.attachmentName;
      prevState.flaginfo.attachmentGuid = flagDetail.attachmentGuid;
      prevState.fileName = flagDetail.attachmentName;
      dispatch({ type: "flagDetails", data: "" });
    }
    if (FlagAttachment) {
      prevState.flaginfo.attachmentName = FlagAttachment.FileName;
      prevState.flaginfo.attachmentGuid = FlagAttachment.Guid;
      prevState.fileName = FlagAttachment.FileName;
      dispatch({ type: "postFlagAttachmentUploadSuccess", data: null });
    }
    if (prevState.file !== "") {
      dispatch(postFlagAttachment(prevState.file));
      prevState.file = "";
    }
    if (GetFlagApplicableService && GetFlagApplicableService !== "") {
      prevState.ApplicableServicesList =
        GetFlagApplicableService &&
        GetFlagApplicableService.map((u) => {
          let data = {
            flagApplicableServiceId: u.flagApplicableServiceId,
            flagId: u.flagId,
            serviceType: u.serviceType,
            serviceTypeId: u.serviceTypeId,
            equipmentId: u.equipmentId,
            isShore: u.isShore,
            equipmentName: u.equipmentName,
            capacity: u.capacity,
            category: u.category,
            equipmentType: u.equipmentType,
            radioButton: u.isShore ? "Shore" : "Ship",
            isDeleted: false,
          };
          return data;
        });
      dispatch({ type: "getFlagApplicableServiceSuccess", data: "" });
    }
    if (FlagApplicableServices) {
      prevState.ApplicableServicesList = FlagApplicableServices;
    }
    if (
      applicableServiceType &&
      applicableServiceType !== "" &&
      prevState.ApplicableServices &&
      prevState.ApplicableServices.length === 0
    ) {
      dispatch({ type: "getServiceTypeIntervalListFlagSuccess", data: "" });
      prevState.ApplicableServices =
        applicableServiceType.length &&
        applicableServiceType.map((d, i) => {
          let obj = {
            serviceType: d.serviceType,
            serviceTypeId: d.serviceTypeId,
            equipmentId: prevState.flaginfo.equipmentId,
            equipmentName: prevState.flaginfo.equipmentName,
            capacity: prevState.flaginfo.capacity,
            category: prevState.flaginfo.category,
            equipmentType: prevState.flaginfo.equipmentType,
            isShore: false,
            isDeleted: false,
            radioButton: "",
            flagApplicableServiceId: 0,
            flagId: parseInt(match.params.id),
          };
          return obj;
        });
    }
  }
  render() {
    const { t } = this.props;
    const { ApplicableServices } = this.state;
    return <div className="pb-3">{this.renderCardData()}</div>;
  }

  renderCardData() {
    const {
      EquipmentNameListAndId,
      FlagApplicableServices,
      Loading,
      FlagManagementDetails,
    } = this.props;
    const { ApplicableServicesList } = this.state;
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3 ">
          <div className="col-lg-12">
            <div className="panel-box search-filter-box">
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1a3464",
                    color: "white",
                  }}
                >
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                   {t("FlagScreen.FlagDetails")}
                  </h5>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-sm-6 mb-1">
                  <span>
                    <strong>{t("FlagScreen.Title")}: </strong>
                    <span className="lato">
                      {FlagManagementDetails?.countryName
                        ? FlagManagementDetails?.countryName
                        : ""}
                    </span>
                  </span>
                </div>

                <div className="col-sm-6 mb-1">
                  <span>
                    <strong>{t("FlagScreen.Attachment")} : </strong>
                    <span className="italicFont ">
                      {FlagManagementDetails?.attachmentName}{" "}
                    </span>
                    {FlagManagementDetails?.attachmentName ? (
                      <i
                        className="fa fa-download click ml-1"
                        onClick={() =>
                          this.DownloadDoc(
                            FlagManagementDetails?.attachmentName,
                            FlagManagementDetails?.attachmentGuid
                          )
                        }
                        aria-hidden="true"
                        style={{
                          color: " #1a3464",
                          fontSize: "1.2rem",
                        }}
                      ></i>
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              </div>

              <div className="search-filter-box">
                <div
                  className="card mt-2 MM-card-header"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {t("ClassScreen.ApplicableServices")}
                    </h5>
                  </div>
                </div>

                {ApplicableServicesList && ApplicableServicesList.length ? (
                  ApplicableServicesList.map((item, index) => {
                    if (!item.isDeleted) {
                      return (
                        <div
                          className="card m-3"
                          style={{
                            backgroundColor: "#f0f0f0",
                            overflow: "hidden",
                            position: "relative",
                          }}
                        >
                          <div className="p-3">
                            <div className="resource-list-auth-date">
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-12 m-auto">
                                  <div className="row">
                                    <div className="col-sm-7">
                                      <span>
                                        <strong>
                                          {t(
                                            "ShipEquipmentStatusScreen.EquipmentName"
                                          )}{" "}
                                          :{" "}
                                        </strong>
                                        {item.equipmentName}&nbsp; (
                                        {item.category &&
                                        (item.capacity || item.equipmentType)
                                          ? item.category + ","
                                          : item.category
                                          ? item.category
                                          : ""}
                                        &nbsp;{" "}
                                        {item.capacity &&
                                        (item.category || item.equipmentType)
                                          ? item.capacity + ","
                                          : item.capacity
                                          ? item.capacity
                                          : ""}
                                        &nbsp;{" "}
                                        {item.equipmentType
                                          ? item.equipmentType
                                          : ""}
                                        )
                                      </span>
                                    </div>
                                    <div className="col-sm-3">
                                      <span>
                                        <strong>
                                          {t("content.Servicetype")} :{" "}
                                        </strong>
                                        {item.serviceType}
                                      </span>
                                    </div>
                                    <div className="col-sm-2">
                                      <span>
                                        <strong>
                                          {t("ComplianceandBudgetScreen.Type")}{" "}
                                          :{" "}
                                        </strong>
                                        {item.radioButton}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })
                ) : (
                  <div
                    className="card m-3"
                    style={{ overflow: "hidden", position: "relative" }}
                  >
                    <div class="container">
                      <h6 className="resource-list-title no-item-card">
                        {t("CommonText.NoTasks")}
                      </h6>
                    </div>
                  </div>
                )}

                <div className="col-lg-12 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}
                    >
                      {" "}
                      {t("ComplianceandBudgetScreen.Cancel")}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  hideSidePanel() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/MasterData/Flag");
  }
  DownloadDoc(attachmentName, attachmentGuid) {
    this.props.dispatch(DownloadAttachment(attachmentName, attachmentGuid));
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    flagDetail: state.lookupReducer.flagDetail || null,
    Loading: state.PageLoaderReducer.loading,
    FlagAttachment: state.lookupReducer.FlagAttachment || null,
    GetFlagApplicableService:
      state.lookupReducer.GetFlagApplicableService || null,
    EquipmentNameListAndId:state.MasterScreenReducer.EquipmentNameListAndId || [] ,
    FlagManagementDetails:state.MasterScreenReducer.FlagManagementDetails,
    applicableServiceType:
      state.MasterScreenReducer.applicableServiceTypeInterval || null,
    FlagApplicableServices:
      state.MasterScreenReducer.FlagApplicableServices || null,
  };
}
export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(FlagDetails))
);
